import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import ScrollToTop from "@/components/ScrollToTop";
import { LangProvider } from "@/i18n";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import Partner from "@/pages/Partner";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Quote from "@/pages/Quote";
import Trial from "@/pages/Trial";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminTrials from "@/pages/admin/AdminTrials";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";

const MarketingLayout = ({ children }) => (
  <>
    <SmoothScroll />
    <Nav />
    <main>{children}</main>
    <Footer />
    <ChatWidget />
  </>
);

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster
          theme="dark"
          position="bottom-left"
          toastOptions={{
            style: {
              background: "#111216",
              border: "1px solid #22242b",
              color: "#fafafa",
              fontFamily: "IBM Plex Sans, sans-serif",
              borderRadius: "0",
            },
          }}
        />
        <Routes>
          {/* Marketing */}
          <Route path="/" element={<MarketingLayout><Home /></MarketingLayout>} />
          <Route path="/chi-siamo" element={<MarketingLayout><About /></MarketingLayout>} />
          <Route path="/servizi" element={<MarketingLayout><Services /></MarketingLayout>} />
          <Route path="/prodotti" element={<MarketingLayout><Products /></MarketingLayout>} />
          <Route path="/preventivo" element={<MarketingLayout><Quote /></MarketingLayout>} />
          <Route path="/prova-a-casa" element={<MarketingLayout><Trial /></MarketingLayout>} />
          <Route path="/payment/success" element={<MarketingLayout><PaymentSuccess /></MarketingLayout>} />
          <Route path="/payment/cancel" element={<MarketingLayout><PaymentCancel /></MarketingLayout>} />
          <Route path="/partner" element={<MarketingLayout><Partner /></MarketingLayout>} />
          <Route path="/blog" element={<MarketingLayout><Blog /></MarketingLayout>} />
          <Route path="/blog/:slug" element={<MarketingLayout><BlogPost /></MarketingLayout>} />
          <Route path="/contatti" element={<MarketingLayout><Contact /></MarketingLayout>} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="prodotti" element={<AdminProducts />} />
            <Route path="preventivi" element={<AdminQuotes />} />
            <Route path="prove" element={<AdminTrials />} />
            <Route path="iscritti" element={<AdminSubscribers />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<MarketingLayout><NotFound /></MarketingLayout>} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}
